module.exports = __webpack_public_path__ + "img/education5.bba7a246.png";